module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "popover-demo",
    attrs: {
      "title": "Popover"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "placement",
      "description": "位置",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('Popover', {
    attrs: {
      "placement": 'top-left'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("上左")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'top'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("上中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'top-right'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("上右")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Popover', {
    attrs: {
      "placement": 'left-top'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("左上")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'left'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("左中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'left-bottom'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("左下")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('Popover', {
    attrs: {
      "placement": 'right-top'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("右上")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'right'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("右中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'right-bottom'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("右下")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Popover', {
    attrs: {
      "placement": 'bottom-left'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("下左")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'bottom'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("下中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'bottom-right'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("下右")])], 1)], 1)])]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "trigger",
      "description": "触发类型",
      "code": _vm.trigger_code
    },
    slot: "right"
  }, [_c('Popover', [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Click")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Hover")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "trigger": "focus"
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Focus")])], 1), _vm._v(" "), _c('Popover', {
    ref: "manual_popover",
    attrs: {
      "trigger": "manual"
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$refs.manual_popover.toggle()
      }
    },
    slot: "reference"
  }, [_vm._v("Manual")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "directive",
      "description": "通过指令触发, `Popover` 必须在 触发元素之前",
      "code": _vm.directive_code
    },
    slot: "right"
  }, [_c('Popover', {
    ref: "popover"
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")])]), _vm._v(" "), _c('Btn', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }]
  }, [_vm._v("Click")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "event",
      "description": "回调事件",
      "code": _vm.event_code
    },
    slot: "right"
  }, [_c('Popover', {
    ref: "popover",
    on: {
      "show": function($event) {
        _vm.$toast('Show')
      },
      "hide": function($event) {
        _vm.$toast('hide')
      }
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Click")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660ae0fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Popover.vue
// module id = 667
// module chunks = 0